import React, { useState } from 'react';
import $ from 'jquery';
import {
    mdiArrowDownCircleOutline,
    mdiArrowLeftRight,
    mdiArrowTopRightThin,
    mdiArrowUpCircleOutline,
    mdiBrush,
    mdiChevronUp,
    mdiCloudOutline,
    mdiCommentProcessing,
    mdiCommentText,
    // mdiContentCopy,
    mdiContentPaste,
    mdiCursorText,
    mdiFitToPageOutline,
    mdiFormatColorFill,
    mdiFormatColorHighlight,
    mdiFormatStrikethrough,
    mdiFormatText,
    mdiFormatTextbox,
    mdiFormatUnderline,
    mdiFormatUnderlineWavy,
    mdiGesture,
    mdiHandBackLeftOutline,
    mdiImagePlus,
    mdiMagnify,
    mdiMagnifyScan,
    mdiPalette,
    mdiRotateLeft,
    mdiRotateRight,
    mdiRuler,
    mdiSelectDrag,
    mdiShapeSquarePlus,
    mdiTextureBox,
    mdiVectorCircle,
    mdiVectorLine,
    mdiVectorPolygon,
    mdiVectorPolyline,
    mdiVectorSquare,
} from '@mdi/js';

import RibbonGroup from './RibbonGroup';
import type { IRibbonTabConfig } from './RibbonConfig';

import styles from './Ribbon.module.scss';
import {
    eplassSliceColor,
    eplassSliceFillColor,
    eplassSliceLineWidth,
    eplassSliceLineStyle,
    eplassSliceLineStart,
    eplassSliceLineEnd,
    eplassSliceListColors,
    eplassSliceListFillColors,
    eplassSliceListLineWidths,
    eplassSliceListLineStyles,
    eplassSliceListLineStarts,
    eplassSliceListLineEnds,
    eplassSliceViewMode,
    eplassSliceSelections,
    eplassSliceLists,
    eplassSliceRibbonRefresh,
    eplassSliceListLineCloudyStyles,
    eplassSliceCloudyLineStyle,
    eplassSliceArrowStart,
    eplassSliceArrowEnd,
} from '../../../Redux/EplassSlice';
import { useSelector } from 'react-redux';
import RibbonButtonSize from './RibbonButtonSize';
import ribbonMenu from '../../../config/ribbonMenu.json';
import type Command from '../../Commands/_Command';
import { GlobalVariables } from '../../../pdf/GlobalVariables';
import i18next from 'i18next';

import CustomButtonGroupController from '../../Commands/CustomButtonGroupController';
import GenericDropdownButton from '../../Commands/GenericDropdownButton';
import DocPropsController from '../../Commands/DocPropsController';
import GoToPageController from '../../Commands/GoToPageController';
import NullButton from '../../Commands/NullButton';
import StateCommandButton from '../../Commands/StateCommandButton';
import RotationController from '../../Commands/RotationController';
import StampSelector from '../../Commands/StampSelector';
import ZoomInButton from '../../Commands/ZoomInButton';
import ZoomController from '../../Commands/ZoomController';
import ZoomLevelButton from '../../Commands/ZoomLevelButton';
import ZoomOutButton from '../../Commands/ZoomOutButton';
import TitleOnlyButtonController from '../../Commands/TitleOnlyButtonController';

import {
    devError,
    devErrorOnce,
    removeTransparency,
    toCSSColor,
    isLightColor,
    translateLineStyle,
    CSSBlack,
    CSSWhite,
    intColor,
    generateUniqueKey,
} from '../../../utils';
import { PdfViewerViewModeFlag, RotationDirection } from '../../../pdf/Enums';
import {
    apryseEventSliceSelectedAnnotationIds,
    apryseEventSliceCurrentScale,
} from '../../../Redux/ApryseEventSlice';
import { selectedStateName } from '../../../Redux/SelectedStateSlice';
import { BorderInfoToStyleString } from '../../../pdf/stateHandler/Helper';
import { isEmpty } from 'ramda';
import { Button } from '@mui/material';
import { ArrowLeft, ArrowRight } from '@mui/icons-material';
import { ApryseUpdater } from '../../../pdf/ApryseUpdater';
import { ApryseSDK } from '../../../pdf/ApryseSDK';
import Icon from '@mdi/react';
import type { Core } from '@pdftron/webviewer';
import CopyController from '../../Commands/CopyController';
import { ReduxUpdater } from '../../../pdf/ReduxUpdater';
import { RedliningActionLogger } from '../../../pdf/RedliningActionLogger';
import SessionCopyController from '../../Commands/SessionCopyController';
import SessionPasteController from '../../Commands/SessionPasteController';

type Commands =
    | 'hand'
    | 'showDocProps'
    | 'selectionBox'
    | 'zoomIn'
    | 'zoomOut'
    | 'zoomLevels'
    | 'zoomOriginalSize'
    | 'zoomFitWidth'
    | 'zoomFitPage'
    | 'rotateCCW'
    | 'rotateCW'
    | 'colorOptions'
    | 'createTypewriter'
    | 'createNote'
    | 'createTextbox'
    | 'createCallout'
    | 'selectText'
    | 'createHighlight'
    | 'createStrikeOut'
    | 'createSquiggly'
    | 'createUnderline'
    | 'createCaret'
    | 'createArrow'
    | 'createLine'
    | 'createPolyline'
    | 'createPolygon'
    | 'createPolygonCloud'
    | 'createCircle'
    | 'createSquare'
    | 'createDistance'
    | 'createPerimeter'
    | 'createArea'
    | 'createPencil'
    | 'createImage'
    | 'marquee';

// Changes marquee on zoomToBox.
const stateNameMapping: Partial<Record<Commands, string>> = {
    // marquee: marqueeStateHandlerName,
};

export const lineWidthIcon = {
    // Width
    lineWidth1: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 24">
            <path fill="none" stroke="currentColor" strokeWidth="1" d="m0 11h48" />
        </svg>
    ),
    lineWidth2: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 24">
            <path fill="none" stroke="currentColor" strokeWidth="2" d="m0 11h48" />
        </svg>
    ),
    lineWidth3: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 24">
            <path fill="none" stroke="currentColor" strokeWidth="3" d="m0 11h48" />
        </svg>
    ),
    lineWidth4: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 24">
            <path fill="none" stroke="currentColor" strokeWidth="4" d="m0 11h48" />
        </svg>
    ),
    lineWidth6: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 24">
            <path fill="none" stroke="currentColor" strokeWidth="6" d="m0 11h48" />
        </svg>
    ),
    lineWidth8: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 24">
            <path fill="none" stroke="currentColor" strokeWidth="8" d="m0 11h48" />
        </svg>
    ),
    lineWidth10: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 24">
            <path fill="none" stroke="currentColor" strokeWidth="10" d="m0 11h48" />
        </svg>
    ),
    lineWidth12: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 24">
            <path fill="none" stroke="currentColor" strokeWidth="12" d="m0 11h48" />
        </svg>
    ),
};

export const lineStyleIcon = {
    // Style
    lineStyleSolid: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 24">
            <path fill="none" stroke="currentColor" strokeWidth="4" d="m0 12h48" />
        </svg>
    ),
    lineStyleDashedS: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 24">
            <path
                fill="none"
                stroke="currentColor"
                strokeWidth="4"
                strokeDasharray="3,3"
                d="m0 12h48"
            />
        </svg>
    ),
    lineStyleDashedM: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 24">
            <path
                fill="none"
                stroke="currentColor"
                strokeWidth="4"
                strokeDasharray="6,3"
                d="m0 12h48"
            />
        </svg>
    ),
    lineStyleDashedL: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 24">
            <path
                fill="none"
                stroke="currentColor"
                strokeWidth="4"
                strokeDasharray="9,3"
                d="m0 12h48"
            />
        </svg>
    ),
    lineStyleDashedLS: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 24">
            <path
                fill="none"
                stroke="currentColor"
                strokeWidth="4"
                strokeDasharray="9,3,3,3"
                d="m0 12h48"
            />
        </svg>
    ),
    lineStyleDashedLXL: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 24">
            <path
                fill="none"
                stroke="currentColor"
                strokeWidth="4"
                strokeDasharray="9,6,18,6"
                d="m0 12h48"
            />
        </svg>
    ),
    lineStyleDashedXLM: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 24">
            <path
                fill="none"
                stroke="currentColor"
                strokeWidth="4"
                strokeDasharray="18,6,6,6"
                d="m0 12h48"
            />
        </svg>
    ),
    lineStyleCloudyS: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 24">
            <path
                fill="none"
                strokeWidth="2"
                stroke="currentColor"
                d="m113.2 7.4c2.6-4.2 6.2-3.8 8.8-2.7 4.3 1.9 3.9 5.6 3.9 5.6m-24.5-2.9c2.6-4.2 6.2-3.8 8.8-2.7 4.3 1.9 3.9 5.6 3.9 5.6m-24.9-2.9c2.6-4.2 6.2-3.8 8.8-2.7 4.3 1.9 3.9 5.6 3.9 5.6m-24.5-2.9c2.6-4.2 6.2-3.8 8.8-2.7 4.3 1.9 3.9 5.6 3.9 5.6m-24.5-2.9c2.6-4.2 6.2-3.8 8.8-2.7 4.3 1.9 3.9 5.6 3.9 5.6m-24.5-2.8c2.6-4.2 6.2-3.8 8.8-2.7 4.3 1.9 3.9 5.6 3.9 5.6m-24.5-2.9c2.6-4.2 6.2-3.8 8.8-2.7 4.3 1.9 3.9 5.6 3.9 5.6m-24.9-2.9c2.6-4.2 6.2-3.8 8.8-2.7 4.3 1.9 3.9 5.6 3.9 5.6m-24.5-2.9c2.6-4.2 6.2-3.8 8.8-2.7 4.3 1.9 3.9 5.6 3.9 5.6m-24.5-2.9c2.6-4.2 6.2-3.8 8.8-2.7 4.3 1.9 3.9 5.6 3.9 5.6m-18.9-6.3c1.1 0 2.2 0.4 3.2 0.8 4.3 1.9 3.9 5.6 3.9 5.6"
            />
        </svg>
    ),
    lineStyleCloudyL: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 24">
            <path
                fill="none"
                strokeWidth="2"
                stroke="currentColor"
                d="m109.8 7.6c3.7-6 8.9-5.4 12.6-3.9 6.2 2.7 5.6 8 5.6 8m-35-4.1c3.7-6 8.9-5.4 12.6-3.9 6.2 2.7 5.6 8 5.6 8m-35-4.1c3.7-6 8.9-5.4 12.6-3.9 6.2 2.7 5.6 8 5.6 8m-35-4.1c3.7-6 8.9-5.4 12.6-3.9 6.2 2.7 5.6 8 5.6 8m-35-4.1c3.7-6 8.9-5.4 12.6-3.9 6.2 2.7 5.6 8 5.6 8m-35-4.1c3.7-6 8.9-5.4 12.6-3.9 6.2 2.7 5.6 8 5.6 8m-35-4.1c3.7-6 8.9-5.4 12.6-3.9 6.2 2.7 5.6 8 5.6 8m-27-9c1.6 0 3.1 0.6 4.6 1.1 6.2 2.7 5.6 8 5.6 8"
            />
        </svg>
    ),
};

/**
 * Creates an SVG Element for a given line ending style.
 * @param path - SVG Contents
 * @param rotate - (Optional) If true, then {@link path} will be rotated by 180 degrees.
 * @returns SVG Element.
 */
const createLineEndingSvg = (path: string, rotate?: boolean): JSX.Element => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <g transform={rotate ? 'rotate(180 15 16)' : 'none'}>
            <path stroke="currentColor" strokeWidth="2" fill="none" d={path} />
        </g>
    </svg>
);

/**
 * Dictionary of SVG paths for the different line endings allowed in the Viewer.
 */
const lineEndings = {
    circle: 'm24 16a11 11 0 1 1 0-1zm-11-0.5h18',
    arrowClosed: 'm1.5 16h30.5zm12 12l-12-12 12-12z',
    diamond: 'm32 16h-20zm-19-12l12 12-12 12-12-12z',
    line: 'm4 6v20zm0 10h24',
    skewed: 'm6 16h24zm-4-10 8 20',
    none: 'm0 16h32',
    arrowOpen: 'm1.5 16h30.5zm12 12l-12-12 12-12',
    arrowReversedClosed: 'm13 16h19zm-12 12l12-12-12-12z',
    arrowReversedOpen: 'm32 16h-19zm-31 12l12-12-12-12',
    square: 'm12 16h20zm-10-10h20v20h-20z',
};

/**
 * Dictionary of icons for the line start dropdown.
 */
export const lineEndingStartIcon = {
    lineEndingStartCircle: createLineEndingSvg(lineEndings.circle),
    lineEndingStartClosed: createLineEndingSvg(lineEndings.arrowClosed),
    lineEndingStartDiamond: createLineEndingSvg(lineEndings.diamond),
    lineEndingStartLine: createLineEndingSvg(lineEndings.line),
    lineEndingStartLineSkewed: createLineEndingSvg(lineEndings.skewed),
    lineEndingStartNone: createLineEndingSvg(lineEndings.none),
    lineEndingStartOpen: createLineEndingSvg(lineEndings.arrowOpen),
    lineEndingStartReversedClosed: createLineEndingSvg(lineEndings.arrowReversedClosed),
    lineEndingStartReversedOpen: createLineEndingSvg(lineEndings.arrowReversedOpen),
    lineEndingStartSquare: createLineEndingSvg(lineEndings.square),
};

/**
 * Dictionary of icons for the line end dropdown.
 */
export const lineEndingEndIcon = {
    lineEndingEndCircle: createLineEndingSvg(lineEndings.circle, true),
    lineEndingEndClosed: createLineEndingSvg(lineEndings.arrowClosed, true),
    lineEndingEndDiamond: createLineEndingSvg(lineEndings.diamond, true),
    lineEndingEndLine: createLineEndingSvg(lineEndings.line, true),
    lineEndingEndLineSkewed: createLineEndingSvg(lineEndings.skewed, true),
    lineEndingEndNone: createLineEndingSvg(lineEndings.none, true),
    lineEndingEndOpen: createLineEndingSvg(lineEndings.arrowOpen, true),
    lineEndingEndReversedClosed: createLineEndingSvg(lineEndings.arrowReversedClosed, true),
    lineEndingEndReversedOpen: createLineEndingSvg(lineEndings.arrowReversedOpen, true),
    lineEndingEndSquare: createLineEndingSvg(lineEndings.square, true),
};

const lineStyleToIconName = (style: string) => {
    switch (style) {
        case 'solid':
            return 'Solid';
        case 'dashed small':
            return 'DashedS';
        case 'dashed medium':
            return 'DashedM';
        case 'dashed large':
            return 'DashedL';
        case 'dashed large small':
            return 'DashedLS';
        case 'dashed large xl':
            return 'DashedLXL';
        case 'dashed xl medium':
            return 'DashedXLM';
        case 'cloudy small':
            return 'CloudyS';
        case 'cloudy large':
            return 'CloudyL';
    }
    devError(new Error(`Unparsed lineStyleToIconName: ${style}`));
};

const lineEndingToIconName = (style: string) => {
    switch (style) {
        case '':
            return '';
        case 'none':
            return 'None';
        case 'circle':
            return 'Circle';
        case 'closedArrow':
            return 'Closed';
        case 'closed':
            return 'Closed';
        case 'diamond':
            return 'Diamond';
        case 'line':
            return 'Line';
        case 'slash':
        case 'line skewed':
            return 'LineSkewed';
        case 'openArrow':
        case 'open':
            return 'Open';
        case 'reverseClosedArrow':
        case 'reversed closed':
            return 'ReversedClosed';
        case 'reverseOpenArrow':
        case 'reversed open':
            return 'ReversedOpen';
        case 'square':
            return 'Square';
    }
    devError(new Error(`Unparsed lineEndingToIconName: ${style}`));
};

/**
 * Component that shows a configurable menu structure in a Microsoft-Office-like structure.
 */
export default () => {
    const [leftButtonVisibility, setLeftButtonVisibility] = React.useState(false);
    const [rightButtonVisibility, setRightButtonVisibility] = React.useState(false);
    const [ribbonMenuRight, setRibbonMenuRight] = React.useState(false);

    const [activeTabIndex, setActiveTabIndex] = useState(0);
    const [commandRegistry, setCommandRegistry] = useState(
        {} as {
            [id in Commands]:
                | NullButton
                | Command
                | Command[]
                | (GenericDropdownButton | GenericDropdownButton[])[];
        },
    );
    const currentViewMode = useSelector(eplassSliceViewMode);
    const selectedAnnotationIds = useSelector(apryseEventSliceSelectedAnnotationIds);
    const currentScale = useSelector(apryseEventSliceCurrentScale);
    const stateName = useSelector(selectedStateName);

    const lists = useSelector(eplassSliceLists);
    const annotationColorList = useSelector(eplassSliceListColors);
    const annotationFillColorList = useSelector(eplassSliceListFillColors);
    const annotationLineWidthsList = useSelector(eplassSliceListLineWidths);
    const annotationLineStylesList = useSelector(eplassSliceListLineStyles);
    const annotationLineCloudyStylesList = useSelector(eplassSliceListLineCloudyStyles);
    const annotationLineStartsList = useSelector(eplassSliceListLineStarts);
    const annotationLineEndsList = useSelector(eplassSliceListLineEnds);

    const selections = useSelector(eplassSliceSelections);
    const selectedColor = useSelector(eplassSliceColor);
    const selectedFillColor = useSelector(eplassSliceFillColor);
    const selectedLineWidth = useSelector(eplassSliceLineWidth);
    const selectedLineStyle = useSelector(eplassSliceLineStyle);
    const selectedCloudyLineStyle = useSelector(eplassSliceCloudyLineStyle);
    const selectedArrowStart = useSelector(eplassSliceArrowStart);
    const selectedArrowEnd = useSelector(eplassSliceArrowEnd);
    const selectedLineStart = useSelector(eplassSliceLineStart);
    const selectedLineEnd = useSelector(eplassSliceLineEnd);
    const forceMenuRefresh = useSelector(eplassSliceRibbonRefresh);
    const cloudyAnnotStyles = ['cloud'];
    const cloudyAnnotTypes = ['cloudy small', 'cloudy large'];
    const lineOrPolylineStyles = ['line', 'polyline'];
    const circlePolygonOrSquareStyles = ['circle', 'polygon', 'square'];

    const colorOptions = () => {
        if (!annotationColorList) {
            return new NullButton('missingCollorOptions');
        }

        const isMainButtonEnabled = () => {
            if (ApryseUpdater.selectedAnnotation === null) {
                return true;
            }
            const supportedTypes = [
                'callout',
                'caret',
                'circle',
                'highlight',
                'pencil',
                'line',
                'polygon',
                'polyline',
                'stamp',
                'strikeout',
                'square',
                'squiggly',
                'textbox',
                'underline',
                'cloud',
            ];
            return supportedTypes.includes(
                ApryseSDK.annotPrettyType(ApryseUpdater.selectedAnnotation),
            );
        };

        const iconColor =
            !ReduxUpdater.useWorkflowColor && ApryseUpdater.selectedAnnotations.length > 0
                ? ApryseUpdater.selectedAnnotations
                      .map(component => ApryseSDK.annotStrokeColor(component))
                      .reduce((a, b) => (a === b ? a : -1))
                : selectedColor;
        const borderBackgroundColor =
            !ReduxUpdater.useWorkflowColor && ApryseUpdater.selectedAnnotations.length > 0
                ? ApryseUpdater.selectedAnnotations
                      .map(component => ApryseSDK.annotStrokeColor(component))
                      .reduce((a, b) => (a === b ? a : -1))
                : selectedColor;

        return [
            new GenericDropdownButton(
                isMainButtonEnabled(),
                'color',
                i18next.t('annotPropsPanel.appearanceProps.borderColor'),
                'colorOptions',
                iconColor.toString(),
                true,
                <Icon path={mdiBrush} />,
                isLightColor(borderBackgroundColor) ? CSSBlack : CSSWhite,
                toCSSColor(borderBackgroundColor),
            ),
            annotationColorList.map(
                color =>
                    new GenericDropdownButton(
                        true,
                        'color',
                        ReduxUpdater.useWorkflowColor
                            ? i18next.t('colors.workflowColor')
                            : i18next.t(`colors.${color.name}`),
                        `colorOption-${color.name}`,
                        color.code.toString(),
                        false,
                        <Icon path={mdiBrush} />,
                        toCSSColor(color.code),
                    ),
            ),
        ];
    };

    const fillColorOptions = () => {
        if (!annotationFillColorList) {
            return new NullButton('missingFillColorOptions');
        }

        const isMainButtonEnabled = () => {
            if (ApryseUpdater.selectedAnnotations.length === 0) {
                if (
                    [
                        ApryseSDK.ToolsENUM.CREATE_CIRCLE,
                        ApryseSDK.ToolsENUM.CREATE_POLYGON,
                        ApryseSDK.ToolsENUM.CREATE_SQUARE,
                        ApryseSDK.ToolsENUM.CREATE_FREETEXT,
                        ApryseSDK.ToolsENUM.CREATE_FREETEXT_CALLOUT,
                        ApryseSDK.ToolsENUM.CREATE_POLYGON_CLOUD,
                    ].includes(stateName)
                ) {
                    return true;
                }
            } else {
                return ApryseUpdater.selectedAnnotations
                    .map(annot =>
                        [
                            ...circlePolygonOrSquareStyles,
                            ...cloudyAnnotStyles,
                            'FreeTextTextbox',
                        ].includes(ApryseSDK.annotPrettyType(annot)),
                    )
                    .every(val => val === true);
            }
            return false;
        };

        const showFillColor =
            !ReduxUpdater.useWorkflowColor && ApryseUpdater.selectedAnnotations.length > 0
                ? ApryseUpdater.selectedAnnotations
                      .map(annot => removeTransparency(ApryseSDK.annotFillColor(annot)))
                      .reduce((a, b) => (a === b ? a : -1))
                : selectedFillColor;

        return [
            new GenericDropdownButton(
                isMainButtonEnabled(),
                'fillColor',
                i18next.t('annotPropsPanel.specificProps.fillColor'),
                'colorFillOptions',
                showFillColor.toString(),
                true,
                <Icon path={mdiPalette} />,
                isLightColor(showFillColor) ? CSSBlack : CSSWhite,
                toCSSColor(showFillColor),
            ),
            annotationFillColorList.map(
                color =>
                    new GenericDropdownButton(
                        true,
                        'fillColor',
                        i18next.t(`colors.${color.name}`),
                        `colorFillOption-${color.name}`,
                        color.code.toString(),
                        false,
                        <Icon path={mdiFormatColorFill} />,
                        toCSSColor(color.code),
                    ),
            ),
        ];
    };

    const lineWidthOptions = () => {
        if (!annotationLineWidthsList) {
            return new NullButton('missingLineWidthOptions');
        }

        const isMainButtonEnabled = () => {
            if (ApryseUpdater.selectedAnnotations.length === 0) {
                if (
                    [
                        ApryseSDK.ToolsENUM.CREATE_ARROW,
                        ApryseSDK.ToolsENUM.CREATE_CIRCLE,
                        ApryseSDK.ToolsENUM.CREATE_LINE,
                        ApryseSDK.ToolsENUM.CREATE_PENCIL,
                        ApryseSDK.ToolsENUM.CREATE_POLYGON,
                        ApryseSDK.ToolsENUM.CREATE_POLYLINE,
                        ApryseSDK.ToolsENUM.CREATE_SQUARE,
                        ApryseSDK.ToolsENUM.CREATE_POLYGON_CLOUD,
                    ].includes(stateName)
                ) {
                    return true;
                }
            } else {
                return ApryseUpdater.selectedAnnotations
                    .map(annot =>
                        [
                            ...lineOrPolylineStyles,
                            ...circlePolygonOrSquareStyles,
                            'pencil',
                        ].includes(ApryseSDK.annotPrettyType(annot)),
                    )
                    .every(val => val === true);
            }
            return false;
        };

        const showLineWidth =
            ApryseUpdater.selectedAnnotations.length > 0
                ? ApryseUpdater.selectedAnnotations
                      .map(annot => ApryseSDK.annotThickness(annot)?.toString())
                      .reduce((a, b) => (a === b ? a : ''))
                : selectedLineWidth.toString();
        return [
            new GenericDropdownButton(
                isMainButtonEnabled(),
                'lineWidth',
                i18next.t('annotPropsPanel.appearanceProps.lineWidth'),
                'lineWidthOptions',
                showLineWidth,
                true,
                lineWidthIcon[`lineWidth${showLineWidth}`],
                CSSBlack,
            ),
            annotationLineWidthsList.map(
                props =>
                    new GenericDropdownButton(
                        true,
                        'lineWidth',
                        props.name,
                        `lineWidthOption-${props.width}`,
                        props.width.toString(),
                        false,
                        lineWidthIcon[props.icon],
                    ),
            ),
        ];
    };

    const lineStyleOptions = () => {
        if (!ApryseSDK.instance) {
            return [];
        }

        if (!annotationLineStylesList) {
            return new NullButton('missingLineStyleOptions');
        }

        const isMainButtonEnabled = () => {
            if (ApryseUpdater.selectedAnnotations.length === 0) {
                if (
                    [
                        ApryseSDK.ToolsENUM.CREATE_ARROW,
                        ApryseSDK.ToolsENUM.CREATE_CIRCLE,
                        ApryseSDK.ToolsENUM.CREATE_LINE,
                        ApryseSDK.ToolsENUM.CREATE_POLYGON,
                        ApryseSDK.ToolsENUM.CREATE_POLYLINE,
                        ApryseSDK.ToolsENUM.CREATE_SQUARE,
                        ApryseSDK.ToolsENUM.CREATE_POLYGON_CLOUD,
                    ].includes(stateName)
                ) {
                    return true;
                }
            } else {
                return ApryseUpdater.selectedAnnotations
                    .map(annot =>
                        [...lineOrPolylineStyles, ...circlePolygonOrSquareStyles].includes(
                            ApryseSDK.annotPrettyType(annot),
                        ),
                    )
                    .every(val => val === true);
            }
            return false;
        };

        const isOptionButtonVisible = (style: string) => {
            if (ApryseUpdater.selectedAnnotations.length === 0) {
                if (
                    cloudyAnnotTypes.includes(style) &&
                    ApryseSDK.ToolsENUM.CREATE_POLYGON_CLOUD === stateName
                ) {
                    return true;
                }
                if (
                    !cloudyAnnotTypes.includes(style) &&
                    ApryseSDK.ToolsENUM.CREATE_POLYGON_CLOUD !== stateName
                ) {
                    return true;
                }
            } else {
                return !(
                    ApryseUpdater.selectedAnnotations
                        .map(annot =>
                            lineOrPolylineStyles.includes(ApryseSDK.annotPrettyType(annot)),
                        )
                        .reduce((a, b) => a || b, true) && cloudyAnnotStyles.includes(style)
                );
            }
            return false;
        };

        const showLineStyle =
            ApryseUpdater.selectedAnnotations.length > 0
                ? ApryseUpdater.selectedAnnotations
                      .map(annot =>
                          BorderInfoToStyleString(annot as Core.Annotations.MarkupAnnotation),
                      )
                      .reduce((a, b) => (a === b ? a : ''))
                : selectedLineStyle;
        return [
            new GenericDropdownButton(
                isMainButtonEnabled(),
                'lineStyle',
                i18next.t('annotPropsPanel.appearanceProps.lineStyle'),
                'lineStyleOptions',
                showLineStyle,
                true,
                lineStyleIcon[`lineStyle${lineStyleToIconName(showLineStyle)}`],
                CSSBlack,
            ),
            annotationLineStylesList.map(
                props =>
                    new GenericDropdownButton(
                        isOptionButtonVisible(props.name),
                        'lineStyle',
                        translateLineStyle(props.name),
                        `lineStyleOption-${props.name}`,
                        props.name,
                        false,
                        lineStyleIcon[props.icon],
                    ),
            ),
        ];
    };

    const lineStyleCloudyOptions = () => {
        if (!annotationLineCloudyStylesList) {
            return new NullButton('missingLineStyleCloudyOptions');
        }

        const isMainButtonEnabled = () => {
            if (ApryseUpdater.selectedAnnotations.length === 0) {
                if (
                    [
                        ApryseSDK.ToolsENUM.CREATE_ARROW,
                        ApryseSDK.ToolsENUM.CREATE_CIRCLE,
                        ApryseSDK.ToolsENUM.CREATE_LINE,
                        ApryseSDK.ToolsENUM.CREATE_POLYGON,
                        ApryseSDK.ToolsENUM.CREATE_POLYLINE,
                        ApryseSDK.ToolsENUM.CREATE_SQUARE,
                        ApryseSDK.ToolsENUM.CREATE_POLYGON_CLOUD,
                    ].includes(stateName)
                ) {
                    return true;
                }
            } else {
                return ApryseUpdater.selectedAnnotations
                    .map(annot => cloudyAnnotStyles.includes(ApryseSDK.annotPrettyType(annot)))
                    .every(val => val === true);
            }
            return false;
        };

        const isOptionButtonVisible = (style: string) => {
            if (ApryseUpdater.selectedAnnotations.length === 0) {
                if (
                    cloudyAnnotTypes.includes(style) &&
                    ApryseSDK.ToolsENUM.CREATE_POLYGON_CLOUD === stateName
                ) {
                    return true;
                }
                if (
                    !cloudyAnnotTypes.includes(style) &&
                    ApryseSDK.ToolsENUM.CREATE_POLYGON_CLOUD !== stateName
                ) {
                    return true;
                }
            } else {
                return !(
                    ApryseUpdater.selectedAnnotations
                        .map(annot =>
                            lineOrPolylineStyles.includes(ApryseSDK.annotPrettyType(annot)),
                        )
                        .reduce((a, b) => a || b, true) && cloudyAnnotStyles.includes(style)
                );
            }
            return false;
        };

        const showLineStyle =
            ApryseUpdater.selectedAnnotations.length > 0
                ? ApryseUpdater.selectedAnnotations
                      .map(annot =>
                            BorderInfoToStyleString(annot as Core.Annotations.MarkupAnnotation),
                      )
                      .reduce((a, b) => (a === b ? a : ''))
                : selectedCloudyLineStyle;
        return [
            new GenericDropdownButton(
                isMainButtonEnabled(),
                'lineCloudyStyle',
                i18next.t('annotPropsPanel.appearanceProps.lineStyle'),
                'lineStyleOptions',
                showLineStyle,
                true,
                lineStyleIcon[`lineStyle${lineStyleToIconName(showLineStyle)}`],
                CSSBlack,
            ),
            annotationLineCloudyStylesList.map(
                props =>
                    new GenericDropdownButton(
                        isOptionButtonVisible(props.name),
                        'lineCloudyStyle',
                        translateLineStyle(props.name),
                        `lineStyleOption-${props.name}`,
                        props.name,
                        false,
                        lineStyleIcon[props.icon],
                    ),
            ),
        ];
    };

    const isMainLineEndingButtonEnabled = () => {
        if (ApryseUpdater.selectedAnnotations.length === 0) {
            if (
                [
                    ApryseSDK.ToolsENUM.CREATE_ARROW,
                    ApryseSDK.ToolsENUM.CREATE_LINE,
                    ApryseSDK.ToolsENUM.CREATE_POLYLINE,
                    ApryseSDK.ToolsENUM.CREATE_FREETEXT_CALLOUT,
                ].includes(stateName)
            ) {
                return true;
            }
        } else {
            return (
                ApryseUpdater.selectedAnnotations
                    .map(annot => lineOrPolylineStyles.includes(ApryseSDK.annotPrettyType(annot)))
                    .every(val => val === true) &&
                ApryseUpdater.selectedAnnotations
                    .map(annot => ApryseSDK.annotIntent(annot) === '')
                    .every(val => val === true)
            );
        }
        return false;
    };

    const lineStartOptions = () => {
        if (!annotationLineStartsList) {
            return new NullButton('missingLineStartOptions');
        }

        let showLineStart =
            ApryseUpdater.selectedAnnotations.length > 0
                ? ApryseUpdater.selectedAnnotations
                      .map(annot =>
                          ApryseSDK.lineEndingStyleToString(ApryseSDK.annotStartStyle(annot)),
                      )
                      .reduce((a, b) => (a === b ? a : ''))
                : selectedLineStart;
        if (stateName === ApryseSDK.ToolsENUM.CREATE_ARROW) {
            showLineStart = selectedArrowStart;
        }
        return [
            new GenericDropdownButton(
                isMainLineEndingButtonEnabled(),
                'lineStart',
                i18next.t('annotPropsPanel.appearanceProps.lineStart'),
                'lineStartOptions',
                showLineStart,
                true,
                lineEndingStartIcon[`lineEndingStart${lineEndingToIconName(showLineStart)}`],
                CSSBlack,
            ),
            annotationLineStartsList.map(
                props =>
                    new GenericDropdownButton(
                        true,
                        'lineStart',
                        i18next.t(`lineEndings.${props.name}`),
                        `lineStartOption-${props.name}`,
                        props.name,
                        false,
                        lineEndingStartIcon[props.icon],
                    ),
            ),
        ];
    };

    const lineEndOptions = () => {
        if (!annotationLineEndsList) {
            return new NullButton('missingLineEndOptions');
        }

        let showLineEnd =
            ApryseUpdater.selectedAnnotations.length > 0
                ? ApryseUpdater.selectedAnnotations
                      .map(annot =>
                          ApryseSDK.lineEndingStyleToString(ApryseSDK.annotEndStyle(annot)),
                      )
                      .reduce((a, b) => (a === b ? a : ''))
                : selectedLineEnd;
        if (stateName === ApryseSDK.ToolsENUM.CREATE_ARROW) {
            showLineEnd = selectedArrowEnd;
        }
        return [
            new GenericDropdownButton(
                isMainLineEndingButtonEnabled(),
                'lineEnd',
                i18next.t('annotPropsPanel.appearanceProps.lineEnd'),
                'lineEndOptions',
                showLineEnd,
                true,
                lineEndingEndIcon[`lineEndingEnd${lineEndingToIconName(showLineEnd)}`],
                CSSBlack,
            ),
            annotationLineEndsList.map(
                props =>
                    new GenericDropdownButton(
                        true,
                        'lineEnd',
                        i18next.t(`lineEndings.${props.name}`),
                        `lineEndOption-${props.name}`,
                        props.name,
                        false,
                        lineEndingEndIcon[props.icon],
                    ),
            ),
        ];
    };

    React.useMemo(() => {
        setActiveTabIndex(currentViewMode === PdfViewerViewModeFlag.Loading ? 0 : 1);
    }, [currentViewMode]);

    /** List of availabe commands in the viewer. */
    React.useMemo(() => {
        const lineStyles = () => {
            if (stateName === ApryseSDK.ToolsENUM.CREATE_POLYGON_CLOUD) {
                return lineStyleCloudyOptions();
            }

            if (ApryseUpdater.selectedAnnotations.length > 0) {
                const filtered = ApryseUpdater.selectedAnnotations.filter(annot =>
                    ApryseSDK.isMarkup(annot),
                );
                if (
                    filtered.length > 0 &&
                    filtered
                        .map(annot => ApryseSDK.annotIntent(annot))
                        .reduce((a, b) => (a === b ? a : '')) !== ''
                ) {
                    return lineStyleCloudyOptions();
                }
            }

            return lineStyleOptions();
        };

        const iconBackgroundColor =
            !ReduxUpdater.useWorkflowColor && selectedAnnotationIds.length > 0
                ? ApryseUpdater.selectedAnnotations
                      .map(annot => intColor(annot.Color))
                      .reduce((a, b) => (a === b ? a : -1))
                : selectedColor;
        const iconColor = isLightColor(iconBackgroundColor) ? CSSBlack : CSSWhite;

        const registry = {
            null: new NullButton(),
            hand: new StateCommandButton(ApryseSDK.ToolsENUM.DEFAULT, mdiHandBackLeftOutline),
            selectionBox: new StateCommandButton(
                ApryseSDK.ToolsENUM.ANNOTATION_EDIT,
                mdiSelectDrag,
            ),
            zoomIn: new ZoomInButton(),
            zoomOut: new ZoomOutButton(),
            zoomOriginalSize: new ZoomController(1.0, mdiHandBackLeftOutline),
            zoomFitWidth: new ZoomController('fitWidth', mdiArrowLeftRight),
            zoomFitPage: new ZoomController('fitPage', mdiFitToPageOutline),
            rotateCCW: new RotationController(RotationDirection.counterclockwise, mdiRotateLeft),
            rotateCW: new RotationController(RotationDirection.clockwise, mdiRotateRight),

            zoomLevels: GlobalVariables.zoomLevels.map(
                level => new ZoomLevelButton(`${level * 100}%`, level, false),
            ),
            zoomIndicator: new TitleOnlyButtonController(
                'zoomIndicator',
                `${Math.round(currentScale * 100)}%`,
                mdiMagnify,
                true,
            ),
            colorOptions: colorOptions(),
            fillColorOptions: fillColorOptions(),
            lineWidthOptions: lineWidthOptions(),
            lineStyleOptions: lineStyles(),
            lineStartOptions: lineStartOptions(),
            lineEndOptions: lineEndOptions(),
            stamps: new StampSelector(),

            // unitScale: new CustomButtonGroupController('unitScale'),
            pages: new CustomButtonGroupController('pages'),
            pageUp: new GoToPageController('Up', mdiArrowUpCircleOutline),
            pageDown: new GoToPageController('Down', mdiArrowDownCircleOutline),
            showDocProps: new DocPropsController(),
            // deleteAnnots: new DeleteAnnotController(),

            marquee: new StateCommandButton(ApryseSDK.ToolsENUM.MARQUEE_ZOOM_TOOL, mdiMagnifyScan),

            createImage: new StateCommandButton(
                ApryseSDK.ToolsENUM.INSERT_IMAGE_TOOL,
                mdiImagePlus,
                iconColor,
                toCSSColor(iconBackgroundColor),
            ),
            createTypewriter: new StateCommandButton(
                ApryseSDK.ToolsENUM.CREATE_FREETEXT_TYPEWRITER,
                mdiFormatText,
                iconColor,
                toCSSColor(iconBackgroundColor),
            ),
            createNote: new StateCommandButton(
                ApryseSDK.ToolsENUM.CREATE_NOTE,
                mdiCommentProcessing,
                iconColor,
                toCSSColor(iconBackgroundColor),
            ),
            createTextbox: new StateCommandButton(
                ApryseSDK.ToolsENUM.CREATE_FREETEXT,
                mdiFormatTextbox,
                iconColor,
                toCSSColor(iconBackgroundColor),
            ),
            createCallout: new StateCommandButton(
                ApryseSDK.ToolsENUM.CREATE_FREETEXT_CALLOUT,
                mdiCommentText,
                iconColor,
                toCSSColor(iconBackgroundColor),
            ),

            selectText: new StateCommandButton(ApryseSDK.ToolsENUM.TEXT_SELECT, mdiCursorText),
            createHighlight: new StateCommandButton(
                ApryseSDK.ToolsENUM.CREATE_TEXT_HIGHLIGHT,
                mdiFormatColorHighlight,
                iconColor,
                toCSSColor(iconBackgroundColor),
            ),
            createStrikeOut: new StateCommandButton(
                ApryseSDK.ToolsENUM.CREATE_TEXT_STRIKEOUT,
                mdiFormatStrikethrough,
                iconColor,
                toCSSColor(iconBackgroundColor),
            ),
            createSquiggly: new StateCommandButton(
                ApryseSDK.ToolsENUM.CREATE_TEXT_SQUIGGLY,
                mdiFormatUnderlineWavy,
                iconColor,
                toCSSColor(iconBackgroundColor),
            ),
            createUnderline: new StateCommandButton(
                ApryseSDK.ToolsENUM.CREATE_TEXT_UNDERLINE,
                mdiFormatUnderline,
                iconColor,
                toCSSColor(iconBackgroundColor),
            ),
            createCaret: new StateCommandButton(
                'ToDO: ApryseSDK.ToolsENUM.CREATE_CARET',
                mdiChevronUp,
                iconColor,
                toCSSColor(iconBackgroundColor),
            ),

            createCircle: new StateCommandButton(
                ApryseSDK.ToolsENUM.CREATE_CIRCLE,
                mdiVectorCircle,
                iconColor,
                toCSSColor(iconBackgroundColor),
            ),
            createPencil: new StateCommandButton(
                ApryseSDK.ToolsENUM.CREATE_PENCIL,
                mdiGesture,
                iconColor,
                toCSSColor(iconBackgroundColor),
            ),
            createArrow: new StateCommandButton(
                ApryseSDK.ToolsENUM.CREATE_ARROW,
                mdiArrowTopRightThin,
                iconColor,
                toCSSColor(iconBackgroundColor),
            ),
            createLine: new StateCommandButton(
                ApryseSDK.ToolsENUM.CREATE_LINE,
                mdiVectorLine,
                iconColor,
                toCSSColor(iconBackgroundColor),
            ),
            createPolygonCloud: new StateCommandButton(
                ApryseSDK.ToolsENUM.CREATE_POLYGON_CLOUD,
                mdiCloudOutline,
                iconColor,
                toCSSColor(iconBackgroundColor),
            ),
            createPolygon: new StateCommandButton(
                ApryseSDK.ToolsENUM.CREATE_POLYGON,
                mdiVectorPolygon,
                iconColor,
                toCSSColor(iconBackgroundColor),
            ),
            createPolyline: new StateCommandButton(
                ApryseSDK.ToolsENUM.CREATE_POLYLINE,
                mdiVectorPolyline,
                iconColor,
                toCSSColor(iconBackgroundColor),
            ),
            createSquare: new StateCommandButton(
                ApryseSDK.ToolsENUM.CREATE_SQUARE,
                mdiVectorSquare,
                iconColor,
                toCSSColor(iconBackgroundColor),
            ),
            createArea: new StateCommandButton(
                ApryseSDK.ToolsENUM.CREATE_MEASUREMENT_AREA,
                mdiTextureBox,
                iconColor,
                toCSSColor(iconBackgroundColor),
            ),
            createDistance: new StateCommandButton(
                ApryseSDK.ToolsENUM.CREATE_MEASUREMENT_DISTANCE,
                mdiRuler,
                iconColor,
                toCSSColor(iconBackgroundColor),
            ),
            createPerimeter: new StateCommandButton(
                ApryseSDK.ToolsENUM.CREATE_MEASUREMENT_PERIMETER,
                mdiShapeSquarePlus,
                iconColor,
                toCSSColor(iconBackgroundColor),
            ),

            copy: new CopyController(),
            paste: new StateCommandButton(
                ApryseSDK.ToolsENUM.PASTE_PREVIEW,
                mdiContentPaste,
                undefined,
                undefined,
                ApryseSDK.canSessionPaste,
            ),

            sessionCopy: new SessionCopyController(),
            sessionPaste: new SessionPasteController(),
        };
        setCommandRegistry(registry);
    }, [forceMenuRefresh, lists, selections, selectedAnnotationIds, stateName, currentScale]);

    const ribbonConfig = React.useMemo(() => {
        const RibbonConfig: IRibbonTabConfig[] = [];
        if (!commandRegistry || isEmpty(commandRegistry)) {
            return [];
        }
        if (!ribbonMenu.menu[currentViewMode.toString()]) {
            throw Error(`Missing menu configuration for '${currentViewMode.toString()}'!`);
        }
        Object.keys(ribbonMenu.menu[currentViewMode.toString()]).forEach(key => {
            if (!isEmpty(ribbonMenu.menu[currentViewMode.toString()][key])) {
                RibbonConfig.push({
                    title: key,
                    groups: ribbonMenu.menu[currentViewMode.toString()][key].map(g => {
                        return g
                            .map(s => {
                                if (Array.isArray(s)) {
                                    return s
                                        .map(x => {
                                            if (Array.isArray(x)) {
                                                return x
                                                    .map(y => {
                                                        if (Array.isArray(y)) {
                                                            return y
                                                                .map(z => {
                                                                    if (Array.isArray(z)) {
                                                                        return z
                                                                            .map(q => {
                                                                                const key =
                                                                                    Object.keys(
                                                                                        q,
                                                                                    )[0];
                                                                                if (
                                                                                    commandRegistry[
                                                                                        key
                                                                                    ] !== undefined
                                                                                ) {
                                                                                    return {
                                                                                        config: commandRegistry[
                                                                                            key
                                                                                        ],
                                                                                        size:
                                                                                            q[
                                                                                                key
                                                                                            ] ??
                                                                                            RibbonButtonSize.DropDown,
                                                                                    };
                                                                                }
                                                                                devErrorOnce(
                                                                                    new Error(
                                                                                        `Command with key '${key}' is not defined!`,
                                                                                    ),
                                                                                );
                                                                                return null;
                                                                            })
                                                                            .filter(
                                                                                q => q !== null,
                                                                            );
                                                                    }
                                                                    const key = Object.keys(z)[0];
                                                                    if (
                                                                        commandRegistry[key] !==
                                                                        undefined
                                                                    ) {
                                                                        return {
                                                                            config: commandRegistry[
                                                                                key
                                                                            ],
                                                                            size:
                                                                                z[key] ??
                                                                                RibbonButtonSize.DropDown,
                                                                        };
                                                                    }
                                                                    devErrorOnce(
                                                                        new Error(
                                                                            `Command with key '${key}' is not defined!`,
                                                                        ),
                                                                    );
                                                                    return null;
                                                                })
                                                                .filter(z => z !== null);
                                                        }
                                                        const key = Object.keys(y)[0];
                                                        if (commandRegistry[key] !== undefined) {
                                                            return {
                                                                config: commandRegistry[key],
                                                                size:
                                                                    y[key] ??
                                                                    RibbonButtonSize.SmallIconWithText,
                                                            };
                                                        }
                                                        devErrorOnce(
                                                            new Error(
                                                                `Command with key '${key}' is not defined!`,
                                                            ),
                                                        );
                                                        return null;
                                                    })
                                                    .filter(y => y !== null);
                                            }
                                            const key = Object.keys(x)[0];
                                            if (commandRegistry[key] !== undefined) {
                                                if (Array.isArray(commandRegistry[key])) {
                                                    // This is a property selector drop down
                                                    const dropDown = commandRegistry[key];
                                                    if (dropDown.length < 2) {
                                                        return null;
                                                    }
                                                    return [
                                                        {
                                                            config: dropDown[0],
                                                            size: x[key],
                                                        },
                                                        [
                                                            // As Singlegroup
                                                            dropDown[1].map(x => {
                                                                return {
                                                                    config: x,
                                                                    size: x[key],
                                                                };
                                                            }),
                                                        ],
                                                    ];
                                                }
                                                return {
                                                    config: commandRegistry[key],
                                                    size:
                                                        x[key] ??
                                                        RibbonButtonSize.SmallIconWithText,
                                                };
                                            }
                                            devErrorOnce(
                                                new Error(
                                                    `Command with key '${key}' is not defined!`,
                                                ),
                                            );
                                            return null;
                                        })
                                        .filter(x => x !== null);
                                } else {
                                    const key = Object.keys(s)[0];
                                    if (commandRegistry[key] !== undefined) {
                                        return {
                                            config: commandRegistry[key],
                                            size: s[key] ?? RibbonButtonSize.LargeIconWithText,
                                        };
                                    }
                                    devErrorOnce(
                                        new Error(`Command with key '${key}' is not defined!`),
                                    );
                                    return null;
                                }
                            })
                            .filter(x => x !== null);
                    }),
                });
            }
        });
        return RibbonConfig;
    }, [commandRegistry, currentViewMode]);

    // Changes stateManager in the PDFViewer in accordance with defaultTools in ribbonMenu.json.
    React.useMemo(() => {
        const defaultTabState = ribbonMenu.defaultTools[currentViewMode];
        if (!defaultTabState || !ribbonConfig[activeTabIndex]) {
            return;
        }
        const configStateName = defaultTabState[ribbonConfig[activeTabIndex].title];
        ApryseSDK.setToolMode(stateNameMapping[configStateName] ?? configStateName);
    }, [activeTabIndex]);

    const onTabClick = (tabKey: string, tabIndex: number) => {
        setActiveTabIndex(tabIndex);

        if (tabKey == 'annotations' && !RedliningActionLogger.initialLogDone) {
            RedliningActionLogger.appendLog('annotation-tab').then(() => {
                RedliningActionLogger.initialLogDone = true;
            });
        }
    };

    const tabs: JSX.Element[] = ribbonConfig.map((x, i: number) => (
        <button
            id={GlobalVariables.isForTestRun ? `rbnGrpBtn${x.title.toUpperCase()}` : undefined}
            key={generateUniqueKey('rbnGrpBtn', i)}
            onClick={() => onTabClick(x.title, i)}
            className={`${styles.button} ${i === activeTabIndex ? styles.active : ''}`}
        >
            {i18next.t(`tabs.${x.title}`)}
        </button>
    ));

    const groups: JSX.Element[] =
        activeTabIndex >= ribbonConfig.length
            ? []
            : ribbonConfig[activeTabIndex].groups
                  .filter(x => x.length !== 0)
                  .map((x, i: number) => (
                      <RibbonGroup
                          key={generateUniqueKey('rbnGrp', i)}
                          customKey={`rbnGrpElements-${i}`}
                          buttons={x}
                      />
                  ));

    const evaluateButtonVisibility = () => {
        // Wait for the UI to render
        window.requestAnimationFrame(function () {
            const w1 = $('#ribbonMenu').width();
            const w2 = ($('#ribbonMenuContent').width() ?? 0) + 8;

            setRibbonMenuRight(false);
            setLeftButtonVisibility(false);
            setRightButtonVisibility(false);

            if (w1 && w2 && w1 <= w2) {
                setRightButtonVisibility(true);
            } else {
                setLeftButtonVisibility(false);
            }
        });
    };

    React.useMemo(() => {
        evaluateButtonVisibility();
    }, [activeTabIndex, ribbonConfig, forceMenuRefresh]);

    const leftButtonClasses = React.useMemo(() => {
        const buttonStyles = [styles.floatButton];

        if (!leftButtonVisibility) {
            buttonStyles.push(styles.hiddenButton);
        }

        return buttonStyles.join(' ');
    }, [leftButtonVisibility]);

    const rightButtonClasses = React.useMemo(() => {
        const buttonStyles = [styles.floatButton];

        if (!rightButtonVisibility) {
            buttonStyles.push(styles.hiddenButton);
        }

        return buttonStyles.join(' ');
    }, [rightButtonVisibility]);

    const menuClasses = React.useMemo(() => {
        const menuStyles = [styles.content];

        if (ribbonMenuRight) {
            menuStyles.push(styles.ribbonRight);
        } else {
            menuStyles.push(styles.ribbonLeft);
        }

        return menuStyles.join(' ');
    }, [ribbonMenuRight]);

    const leftButtonClick = () => {
        setRibbonMenuRight(false);
        setLeftButtonVisibility(false);
        setRightButtonVisibility(true);
    };

    const rightButtonClick = () => {
        setRibbonMenuRight(true);
        setLeftButtonVisibility(true);
        setRightButtonVisibility(false);
    };

    React.useEffect(() => {
        window.addEventListener('resize', evaluateButtonVisibility);

        return () => {
            window.removeEventListener('resize', evaluateButtonVisibility);
        };
    }, []);

    return (
        <div id="ribbonMenu" className={styles.ribbon}>
            <div id="ribbonMenuTabs" className={styles.tabs}>
                {tabs}
            </div>
            <div id="ribbonMenuContent" className={menuClasses}>
                <Button
                    id="moveMenuLeft"
                    className={leftButtonClasses}
                    color="primary"
                    style={{ left: '0px' }}
                    onClick={leftButtonClick}
                >
                    <ArrowLeft />
                </Button>
                {groups}
                <Button
                    id="moveMenuRight"
                    className={rightButtonClasses}
                    color="primary"
                    style={{ right: '0px' }}
                    onClick={rightButtonClick}
                >
                    <ArrowRight />
                </Button>
            </div>
        </div>
    );
};
